<template>
    <div>
      <div class="align-items-right">
        <p class="title text-right">
          <strong> {{ formatDocumentName() }} </strong>
        </p>
      </div>
  
      <article
        v-if="sia.complex_grade"
        class="tocitem"
        :title="$t('message.find_partner.common_info_Grade')"
      ></article>
      <table v-if="sia.complex_grade">
        <tr>
          <td>
            {{ $t("message.find_partner.common_info_Grade") }}
          </td>
          <td>
            {{ sia.complex_grade }} ({{
              sia.complex_grade < 50
                ? "Плохо"
                : sia.complex_grade < 150
                ? "Нормально"
                : "Хорошо"
            }})
          </td>
        </tr>
        <tr>
          <td>
            {{ $t("message.find_partner.common_info_GradeDescription") }}
          </td>
          <td>
            <div v-html="sia.description"></div>
          </td>
        </tr>
        <tr>
          <td>
            {{ $t("message.find_partner.common_info_as_calculated_grade") }}
          </td>
          <td>
            <div v-html="sia.as_calculated_grade"></div>
          </td>
        </tr>
      </table>
  
      <short-search-results :data="short_search_result"
											:mode="'pdf'"></short-search-results>
    </div>
  </template>
  <script>
  import moment from "moment";
  import ShortSearchResults from '../../short-search/results.vue';
  export default {
    props: ["doc", "doc_additional"],
    components: { ShortSearchResults},
    data() {
      return {
        mode: 'pdf',
        short_search_result: {},
        risk_info_data: {},
        business_fuzzy_info: {
          response_info: {},
        },
        sia: {},
      };
    },
    mounted() {
      this.short_search_result = this.doc;
      this.sia = this.doc.sia;
      setTimeout(() => {
        this.$root.$emit("print-pdf", { signature: "", type: "short-reference-search-cn" });
      }, 4000);
    },
    computed: {},
  
    methods: {
      momentum(d) {
        return moment(d).format("D_MM_Y");
      },
      formatDocumentName() {
        var docName = "";
        if (this.doc_additional.searcher_full_name)
          docName += this.doc_additional.searcher_full_name + " ";
        var servicesNames = this.$t("message.find_partner.service_736_213")

        docName += servicesNames;
        docName +=
          ", " + this.$t("message.find_partner.search_parameters") + ": ";
        if (this.doc_additional.keyWord)
          docName += this.doc_additional.keyWord + ", ";
        docName += this.momentum(new Date());
  
        return docName;
      },
    },
    
  };
  </script>
  